module.exports = __webpack_public_path__ + "img/icon-edit-yellow.ee9923dd.svg";